import { render, staticRenderFns } from "./SubPhone.vue?vue&type=template&id=67940f7e&scoped=true&"
import script from "./SubPhone.vue?vue&type=script&lang=js&"
export * from "./SubPhone.vue?vue&type=script&lang=js&"
import style0 from "./SubPhone.vue?vue&type=style&index=0&id=67940f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67940f7e",
  null
  
)

export default component.exports